import { SET_SELECTION_MENU } from "../Types";

const MenuSelectionBarInitialState = {};

export const MenuSelectionBarReducer = (
  state = MenuSelectionBarInitialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SELECTION_MENU: {
      return {
        ...state,
        selectedMenu: payload,
      };
    }
    default:
      return state;
  }
};
